import React, { useState, useEffect, useCallback, useRef } from 'react';
import axios from 'axios';
// import util from 'util';
import constClass from '../../Constants/Constants';
import { useToasts } from 'react-toast-notifications';
import { useParams } from 'react-router';
import moment from 'moment';
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import { useHistory, generatePath } from 'react-router-dom';
import QRCode from "react-qr-code";

const EventInfo = (props) => {
  const { user } = props;
  const { siteId, mallId, eventId } = useParams();
  const [mallLineLiffUrlData, setMallLineLiffUrlData] = useState(null);
  const [eventData, setEventData] = useState(null);
  const [eventInfoData, setEventInfoData] = useState(null);
  const [lockData, setLockData] = useState(false);
  const { addToast } = useToasts();
  const [oldNotifyFlag, setOldNotifyFlag] = useState(false);
  const history = useHistory();
  const [ticketData, setTicketData] = useState(null);
  const refs = useRef({});

  const [eventValues, setEventValues] = useState({
    event_id: null,
    event_name: '',
    point_give: '',
    ticket_id: null,
    event_uuid: null,
    ticket_expire_date: moment().format('YYYYMMDD'),
    point_expire_date: moment().format('YYYYMMDD'),
    bonus_type: constClass.BONUS_TYPE.POINT
  });

  const [values, setValues] = useState({
    checkin_id: null,
    notice_title: '',
    notice_summary: '',
    notice_detail: '',
    notice_image_url: '',
    notice_start_date: null,
    notice_end_date: null,
    uploadfile: null,
    uploadfiletype: null,
    deletefile: null
  });

  const refreshData = useCallback(async () => {
    const jwt = localStorage.getItem('jwt');
    const mallLineLiffUrl = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/mall/${siteId}/${mallId}`)).data.line_liff_url;
    setMallLineLiffUrlData(mallLineLiffUrl);

    var eventInfoData = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/event/${siteId}/${mallId}/${eventId}`, {
      headers: {
        Authorization: `Bearer ${jwt}`,
      }
    })).data;

    var ticketData = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/ticket/${siteId}/${mallId}`, {
      headers: {
        Authorization: `Bearer ${jwt}`,
      }
    })).data;
    setTicketData(ticketData);

    const sysdate = new Date();

    if (!oldNotifyFlag || oldNotifyFlag === constClass.FLAG.OFF) {
      eventInfoData.m_event_infos = eventInfoData.m_event_infos.filter(x => moment(x.notice_end_date) >= moment(sysdate));
    }
    setEventData(eventInfoData);
    setEventInfoData(eventInfoData.m_event_infos);
    setEventValues(eventInfoData);
  }, [siteId, mallId, eventId, oldNotifyFlag]);

  /* 編集ボタン押下 */
  const handleUpdateClick = (data) => {
    const temp = data;
    temp.deletefile = null;
    temp.uploadfiletype = null;
    if (data.notice_image_url != null) temp.uploadfile = `/${siteId}/${constClass.CHECKIN_IMAGE_DIR + data.notice_image_url}`;
    else temp.uploadfile = null;
    temp.notice_title = temp.notice_title ? temp.notice_title : '';
    temp.notice_summary = temp.notice_summary ? temp.notice_summary : '';
    temp.notice_detail = temp.notice_detail ? temp.notice_detail : '';
    temp.notice_start_date = temp.notice_start_date ? moment(temp.notice_start_date, 'YYYYMMDD') : null;
    temp.notice_end_date = temp.notice_end_date ? moment(temp.notice_end_date, 'YYYYMMDD') : null;
    temp.notice_image_url = temp.notice_image_url ? temp.notice_image_url : '';
    setValues(temp);
  }


  /* RESETボタン押下 */
  const handleNoTimeLimitClick = () => {
    setValues({
      ...values,
      notice_start_date: new Date(),
      notice_end_date: new Date(9999, 11, 31),
    });
  }

  /* RESETボタン押下 */
  const handleResetClick = () => {
    setValues({
      checkin_id: null,
      notice_title: '',
      notice_summary: '',
      notice_detail: '',
      notice_image_url: '',
      notice_start_date: null,
      notice_end_date: null,
      uploadfile: null,
      uploadfiletype: null,
      deletefile: null,
    });
  }

  const handleDownloadQRCode = (data) => {
    const svg = document.getElementById(`qr-svg-${data.event_id}`);
    
    if (!svg) return;

    const serializer = new XMLSerializer();
    const svgString = serializer.serializeToString(svg);

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    const img = new Image();
    img.onload = () => {
      canvas.width = img.width + 20; // 余白を追加
      canvas.height = img.height + 20; // 余白を追加
      ctx.fillStyle = 'white'; // 余白の色を指定
      ctx.fillRect(0, 0, canvas.width, canvas.height); // 余白を描画
      ctx.drawImage(img, 10, 10); // QRコードを描画
      // canvas.width = img.width;
      // canvas.height = img.height;
      // ctx.drawImage(img, 0, 0);

      const url = canvas.toDataURL('image/png');
      const a = document.createElement('a');
      a.href = url;
      a.download = data.event_id + '_' + data.event_name + '.png';
      a.click();
    };
    img.src = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgString)));
  };

  /* DB更新 */
  const handlePointUpdateRegistClick = async (data) => {
    const jwt = localStorage.getItem('jwt');
    if ((data.bonus_type === constClass.BONUS_TYPE.TICKET || data.bonus_type === constClass.BONUS_TYPE.BOTH) && !data.ticket_id) {
      window.alert('配布クーポンを選択してください。');
      return;
    }
    if ((data.bonus_type === constClass.BONUS_TYPE.POINT || data.bonus_type === constClass.BONUS_TYPE.BOTH) && !data.point_give) {
      window.alert('付与ポイントを入力してください。');
      return;
    }
    var params = data;
    if (data.uploadfiletype === null) data.uploadfile = null;
    params.ins_name = user.userId;
    params.upd_name = user.userId;
    params.site_id = Number(siteId);
    params.mall_id = Number(mallId);
    params.event_id = Number(eventId);
    if (data.bonus_type === constClass.BONUS_TYPE.TICKET) {
      params.point_give = null;
      params.point_expire_date = null;
    }
    if (data.bonus_type === constClass.BONUS_TYPE.POINT) {
      params.ticket_id = null;
      params.ticket_expire_date = null;
    }
    
    let res;
    try {
      setLockData(true);
      res = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/event/${params.event_id}`, params, {
        headers: {
          Authorization: `Bearer ${jwt}`
        }
      });
    } catch (err) {
      console.log(err);
      if (err.response.data !== null) {
        addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      if (!res) {
      } else if (res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast('登録しました。', { appearance: 'success', autoDismiss: true });
        await refreshData();
      }
      setLockData(false);
      handleResetClick();
    }
  }

  /* DB更新 */
  const handleRegistClick = async (data) => {
    const jwt = localStorage.getItem('jwt');
    if (!data.notice_title) {
      window.alert('お知らせタイトルを入力してください。');
      return;
    }
    if (data.notice_title.length > 50) {
      window.alert('お知らせタイトルは、50文字以内で入力してください。');
      return;
    }
    if (!data.notice_summary) {
      window.alert('お知らせ概要を入力してください。');
      return;
    }
    if (data.notice_summary.length > 200) {
      window.alert('お知らせ概要は、200文字以内で入力してください。');
      return;
    }
    if (data.notice_detail && data.notice_detail.length > 200) {
      window.alert('お知らせ詳細は、200文字以内で入力してください。');
      return;
    }
    if (!data.notice_start_date) {
      window.alert('表示期間開始日を入力してください。');
      return;
    }
    if (!data.notice_end_date) {
      window.alert('表示期間終了日を入力してください。');
      return;
    }
    var params = data;
    if (data.uploadfiletype === null) data.uploadfile = null;
    params.ins_name = user.userId;
    params.upd_name = user.userId;
    params.site_id = siteId;
    params.mall_id = mallId;
    params.event_id = eventId;

    let res;
    try {
      setLockData(true);
      if (params.checkin_id === null || params.checkin_id === "") {
        res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/eventinfo/`, params, {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        });
      } else {
        res = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/eventinfo/${params.checkin_id}`, params, {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        });
      }
    } catch (err) {
      console.log(err);
      if (err.response.data !== null) {
        addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      if (!res) {
      } else if (res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast('登録しました。', { appearance: 'success', autoDismiss: true });
        await refreshData();
      }
      setLockData(false);
      handleResetClick();
    }
  }

  // 二次元コードボタン
  const renderTwoDimensionalCodeButton = (data) => {
    const ref = refs.current[data.event_id];
    return (
      <React.Fragment>
        <button
          type="button"
          className="btn btn-primary mx-1"
          onClick={() => handleDownloadQRCode(data)}
        >
          二次元コード
        </button>
        <div style={{ display: 'none' }}>
          <QRPrintComponent ref={ref} data={data} />
        </div>
      </React.Fragment>
    );
  }
  
  // QRコードを表示するコンポーネント
  const QRPrintComponent = React.forwardRef(({ data }, ref) => (
    <div ref={ref} className="d-flex flex-column align-items-center justify-content-center">
      <div className='align-self-center'>
        <div className='text-center align-self-center mt-4'>イベントID: {data.event_id}</div>
        <div className='text-center align-self-center mt-4'>イベント名: {data.event_name}</div>
        <div className='d-flex justify-content-center align-items-center mt-4'>
          <QRCode
            id={`qr-svg-${data.event_id}`}
            className="qr-detail-img"
            size={500}
            value={`${mallLineLiffUrlData ? mallLineLiffUrlData : process.env.FRONTEND_URL}?page=${constClass.EVENT}&event_uuid=${data.event_uuid}`}
          />
        </div>
      </div>
    </div>
  ));

  /* DB削除 */
  const handleDeleteClick = async (data) => {
    const jwt = localStorage.getItem('jwt');

    if (!window.confirm(`チェックインマスタ[${data.checkin_id}:${data.notice_title}]を削除します。よろしいですか？`)) {
      return;
    }
    const params = {
      site_id: siteId,
      checkin_id: data.checkin_id,
      upd_date: data.upd_date
    };
    let res;
    try {
      setLockData(true);
      res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/eventinfo/delete/`, params, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        }
      });
    } catch (err) {
      if (err.response.data !== null) {
        addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      if (res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast('削除しました。', { appearance: 'success', autoDismiss: true });
        await refreshData();
      }
      setLockData(false);
      handleResetClick();
    }
  }

  const renderUpdateButton = (data) => {
    return (
      <button
        className={`btn btn-primary mx-1`}
        onClick={() => handleUpdateClick(data)}>
        編集
      </button>
    )
  }

  const renderRegistButton = (data) => {
    return (
      <button type="button"
        disabled={lockData || data.notice_title === ''}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleRegistClick(data)}>
        登録
      </button>
    )
  }

  const renderDeleteButton = (data) => {
    return (
      <button type="button"
        disabled={lockData || data.checkin_id === null}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleDeleteClick(data)}>
        削除
      </button>
    )
  }

  const renderResetButton = () => {
    return (
      <button type="button"
        disabled={false}
        className={`btn btn-primary mx-1 w-50 text-nowrap text-center align-self-center`}
        onClick={() => handleResetClick()}>
        リセット
      </button>
    )
  }

  const renderNoTimeLimitButton = () => {
    return (
      <button type="button"
        disabled={lockData}
        className={`btn btn-outline-dark text-black mx-1 w-50 text-nowrap text-center align-self-center`}
        onClick={() => handleNoTimeLimitClick()}>
        期限なし
      </button>
    )
  }

  const renderPointUpdateButton = (data) => {
    return (
      <button type="button"
        disabled={lockData}
        className={`btn btn-primary mx-1 w-100`}
        onClick={() => handlePointUpdateRegistClick(data)}
      >
        更新
      </button>
    )
  }

  const handleChange = (e) => {
    const target = e.target;
    const name = target.name;
    if (name === "oldNotifyFlag") {
      setOldNotifyFlag(target.checked ? constClass.FLAG.ON : constClass.FLAG.OFF);
    } else {
      const value = target.type === "checkbox" ? (target.checked ? constClass.FLAG.ON : constClass.FLAG.OFF) : target.value;
      setValues({ ...values, [name]: value });
    }
  }

  const handleEventChange = (e) => {
    const target = e.target;
    const name = target.name;
    if (name === "oldNotifyFlag") {
      setOldNotifyFlag(target.checked ? constClass.FLAG.ON : constClass.FLAG.OFF);
    } else {
      const value = target.type === "checkbox" ? (target.checked ? constClass.FLAG.ON : constClass.FLAG.OFF) : target.value;
      setEventValues({ ...eventValues, [name]: value });
    }
  }

  const handleChangeFile = (e) => {
    const value = e.target.files[0];
    var reader = new FileReader();
    reader.onloadend = () => {
      setValues({
        ...values,
        uploadfile: reader.result,
        uploadfiletype: value.type,
        deletefile: values.notice_image_url
      });
    }
    reader.readAsDataURL(value);
  }

  const handleDeleteFile = () => {
    setValues({ ...values, uploadfile: null, uploadfiletype: null, deletefile: values.notice_image_url });
  }

  useEffect(() => {
    refreshData();
  }, [refreshData]);

  const handleChangeDate = (name, value) => {
    if (name === "notice_end_date") {
      // 終了日は23:59:59にする
      value = moment(value).endOf('day').toDate();
    } else {
      // 開始日は00:00:00にする
      value = moment(value).startOf('day').toDate();
    }
    setValues({ ...values, [name]: value });
  }

  const renderInput = () => {
    return (
      <div className="mx-1">
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <span>No</span>
          </div>
          <div className="col-2 text-center align-self-center">
            <input type="text" className="form-control" name="checkin_id" defaultValue={values.checkin_id} placeholder="新規" readOnly />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <span>タイトル</span>
          </div>
          <div className="col-5 text-center align-self-center">
            <input type="text" className="form-control" name="notice_title" value={values.notice_title} onChange={handleChange} />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="notice_summary">概要</label>
          </div>
          <div className="col-5 align-self-center">
            <input type="text" className="form-control" name="notice_summary" id="notice_summary" value={values.notice_summary} onChange={handleChange}></input>
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="notice_detail">詳細</label>
          </div>
          <div className="col-5 align-self-center">
            <textarea className="form-control" rows="3" name="notice_detail" id="notice_detail" value={values.notice_detail} onChange={handleChange}></textarea>
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="notice_image_url">画像</label>
          </div>
          <div className="col-5 align-self-center">
            {!(values.uploadfile) && <input type="file" className="form-control-file" name="noticeImage" id="noticeImage" value="" onChange={handleChangeFile} onClick={e => (e.target.value = null)} />}
            {values.uploadfile && <object id="uploadfileview" className="w-100" data={values.uploadfile} type={values.uploadfiletype}><img className="w-100" src={values.uploadfile} alt='uploadfile' /></object>}
            {values.uploadfile && <input type="button" className="form-controll" name="deletefile" id="deletefile" onClick={handleDeleteFile} value="ファイル削除" />}
          </div>
        </div>
        <div className="row mb-4">
          <div className="col-2 pt-1 pr-0 text-center align-self-center">
            <span>表示期間</span>
          </div>
          <div className="col-3 text-center">
            <DatePicker className="custom-select text-left w-100"
              locale="ja" dateFormat="yyyy/MM/dd" monthsShown="1" id={'notice_start_date'} name={'notice_start_date'}
              popperPlacement='bottom'
              selected={values.notice_start_date
                ? (moment.isMoment(values.notice_start_date)
                  ? values.notice_start_date.toDate()
                  : (isNaN(new Date(values.notice_start_date)) ? null : new Date(values.notice_start_date)))
                : null
              }
              onChange={date => handleChangeDate("notice_start_date", date ? date : null)}
              placeholderText="- 選択 -"
              autoComplete='off'
              isClearable={true}
              onFocus={(e) => e.target.blur()}
            />
          </div>
          <div className="col-1 text-center">～</div>
          <div className="col-3 text-center">
            <DatePicker className="custom-select text-left w-100"
              locale="ja" dateFormat="yyyy/MM/dd" monthsShown="1" id={'notice_end_date'} name={'notice_end_date'}
              popperPlacement='bottom'
              selected={values.notice_end_date
                ? (moment.isMoment(values.notice_end_date)
                  ? values.notice_end_date.toDate()
                  : (isNaN(new Date(values.notice_end_date)) ? null : new Date(values.notice_end_date)))
                : null
              }
              onChange={date => handleChangeDate("notice_end_date", date ? date : null)}
              placeholderText="- 選択 -"
              autoComplete='off'
              isClearable={true}
              onFocus={(e) => e.target.blur()}
            />
          </div>
          <div className="col-3 text-center">
            {renderNoTimeLimitButton()}
          </div>
        </div>
        <div className="row pb-4">
          <div className="col-3 text-center">
            {renderRegistButton(values)}
          </div>
          <div className="col-3 text-center">
            {renderDeleteButton(values)}
          </div>
          <div className="col-3 text-center">
            {renderResetButton(values)}
          </div>
        </div>
      </div>
    );
  }

  const renderList = () => {
    if (eventInfoData && eventData && eventData.event_id && !refs.current[eventData.event_id]) {
      refs.current[eventData.event_id] = React.createRef();
    }
    return (
      <div className="row mb-3 p-0 mt-2">
        <div className="col-12 p-0">
          <table className="table table-bordered table-striped">
            <thead className={`table-info`}>
              <tr>
                <td className="text-center align-middle">
                  No
                </td>
                <td className="text-center align-middle">
                  タイトル
                </td>
                <td className="text-center align-middle">
                  表示期間
                </td>
                <td className="text-center align-middle">
                  更新日時
                </td>
                <td className="text-center align-middle">
                  処理
                </td>
              </tr>
            </thead>
            <tbody>
              {eventInfoData && eventInfoData.length > 0 && eventInfoData.map((data, idx) => (
                <tr key={data.checkin_id}>
                  {/* チェックインID */}
                  <td className="text-center align-middle">
                    {data.checkin_id}
                  </td>
                  {/* お知らせタイトル */}
                  <td className="text-center align-middle">
                    {data.notice_title}
                  </td>
                  {/* 表示期間 */}
                  <td className="text-center align-middle">
                    {moment(data.notice_start_date).format('YYYY/MM/DD')}&nbsp;&nbsp;～&nbsp;&nbsp;{moment(data.notice_end_date).format('YYYY/MM/DD')}
                  </td>
                  {/* 更新日時 */}
                  <td className="text-center align-middle">
                    {moment(data.upd_date).format("YYYY/MM/DD HH:mm:ss")}
                  </td>
                  {/* 処理 */}
                  <td className="text-center align-middle text-nowrap">
                    {renderUpdateButton(data)}
                  </td>
                </tr>
              ))
              }
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  const renderGivePoint = () => {
    return (
      <React.Fragment>
        <div className="row mt-3">
          <div className="col-12 my-3">
            <button
              type="button"
              className="btn text-black bg-lightwhite border-black"
              onClick={() => history.push(generatePath(`${props.match.path}event/`, { siteId: props.match.params.siteId, mallId: props.match.params.mallId }))}>
              戻る
            </button>
          </div>
          <div className="col-12 my-3">
            <h4>
              <span>イベントID: {eventId}</span>
              <span className="ml-3">イベント名: {eventData.event_name}</span>
              {renderTwoDimensionalCodeButton(eventValues)}
            </h4>
          </div>
          <div className="col-12 my-3">
            <div className="row align-items-center">
              <div className="col-auto text-center">
                <label htmlFor="bonus_type" className="mb-0">ボーナス区分</label>
              </div>
              <div className="col-auto">
                <select className="form-control" id="bonus_type" name="bonus_type" value={eventValues.bonus_type} onChange={handleEventChange}>
                  <option key={constClass.BONUS_TYPE_NAME.POINT} value={constClass.BONUS_TYPE.POINT}>{constClass.BONUS_TYPE_NAME.POINT}</option>
                  <option key={constClass.BONUS_TYPE_NAME.TICKET} value={constClass.BONUS_TYPE.TICKET}>{constClass.BONUS_TYPE_NAME.TICKET}</option>
                  <option key={constClass.BONUS_TYPE_NAME.BOTH} value={constClass.BONUS_TYPE.BOTH}>{constClass.BONUS_TYPE_NAME.BOTH}</option>
                </select>
              </div>
            </div>
          </div>
          {(eventValues.bonus_type === constClass.BONUS_TYPE.POINT || eventValues.bonus_type === constClass.BONUS_TYPE.BOTH) &&
            <div className="col-12 my-3">
              <div className="row align-items-center">
                <div className="col-auto text-center">
                  <label htmlFor="point_give" className="mb-0">付与ポイント</label>
                </div>
                <div className="col-auto">
                  <input type="text" className="form-control" name="point_give" value={eventValues.point_give} onChange={handleEventChange} />
                </div>
                <div className="col-auto text-center">
                  <label htmlFor="point_expire_date" className="mb-0">ポイント有効期限</label>
                </div>
                <div className="col-auto">
                  <input type="text" className="form-control" name="point_expire_date" value={eventValues.point_expire_date} onChange={handleEventChange} />
                </div>
                <div className="col-auto text-center text-nowrap">
                  {renderPointUpdateButton(eventValues)}
                </div>
              </div>
            </div>
          }
          {(eventValues.bonus_type === constClass.BONUS_TYPE.TICKET || eventValues.bonus_type === constClass.BONUS_TYPE.BOTH) &&
            <div className="col-12 my-3">
              <div className="row align-items-center">
                <div className="col-auto text-center">
                  <label htmlFor="ticket_id" className="mb-0">配布クーポン</label>
                </div>
                <div className="col-auto text-center">
                  <select className="form-control" id="ticket_id" name="ticket_id" value={eventValues.ticket_id || ''} onChange={handleEventChange}>
                    <option value="">- 選択 -</option>
                    {ticketData && ticketData.filter(item => item.ticket_type === constClass.TICKET_TYPE.FREE).map((ticket) => (
                      <option key={ticket.ticket_id} value={ticket.ticket_id}>
                        {ticket.ticket_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-auto text-center">
                  <label htmlFor="ticket_expire_date" className="mb-0">クーポン有効期限</label>
                </div>
                <div className="col-auto text-center">
                  <input type="text" className="form-control" name="ticket_expire_date" value={eventValues.ticket_expire_date} onChange={handleEventChange} />
                </div>
                <div className="col-auto text-center text-nowrap">
                  {renderPointUpdateButton(eventValues)}
                </div>
              </div>
            </div>
          }
        </div>
        <div className='row my-3'>
          <div className='col-9'></div>
          <div className="col-2 text-center align-self-center">
            <label htmlFor="oldNotifyFlag">過去のお知らせを表示する</label>
          </div>
          <div className="col-1 text-left align-self-center">
            <input type="checkbox" className="form-control" id="oldNotifyFlag" name="oldNotifyFlag" value="true" checked={oldNotifyFlag === constClass.FLAG.ON} onChange={handleEventChange}></input>
          </div>
        </div>
      </React.Fragment>
    );
  }

  return (
    <div className="container">
      {eventData === null && eventInfoData === null && <div className="row"><div className="col-12">読み込み中・・・</div></div>}
      {eventData !== null && eventInfoData !== null && (renderGivePoint())}
      {eventData !== null && eventInfoData !== null && (renderList())}
      {renderInput()}
    </div>
  )
}

export default EventInfo;